import React from 'react';
import CoarseType from './modelTypes/CoarseType';

function ConversionModelShelfStep3(props) {
    return <CoarseType {...props} />;
}

export default ConversionModelShelfStep3;
